"use strict";
exports.__esModule = true;
exports.toThematic = void 0;
var types_1 = require("../../types");
var THEMATIC_PRISMIC_TO_LGLP = {
    'Banque et assurance': types_1.Thematic.Bank,
    'Courrier et colis': types_1.Thematic.LetterPackage,
    'Développement territorial': types_1.Thematic.Dt,
    'Développement Territorial': types_1.Thematic.Dt,
    'Excellence logistique': types_1.Thematic.Excellence,
    Innovation: types_1.Thematic.Innovation,
    International: types_1.Thematic.International,
    'Logistique urbaine': types_1.Thematic.Logistic,
    Médias: types_1.Thematic.Medias,
    Partenariats: types_1.Thematic.Partnership,
    'Ressources humaines': types_1.Thematic.HumanResource,
    'Services à la personne': types_1.Thematic.HomeService,
    Télécom: types_1.Thematic.Telecom,
    'Transformation numérique': types_1.Thematic.Digital,
    'Transitions écologiques': types_1.Thematic.Ecology
};
var toThematic = function (prismicThematic, logger) {
    return logger.toConstValue(prismicThematic, THEMATIC_PRISMIC_TO_LGLP);
};
exports.toThematic = toThematic;
//# sourceMappingURL=thematic.js.map